import { useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/lib/api";
import { useLang } from "@/contexts/LangContext";

export default function ResetPassword() {
  const { token } = useParams();
  const { t } = useLang();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: password });
      setDone(true);
      setTimeout(() => navigate("/login", { replace: true }), 2200);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-6 md:px-12 py-24 fade-in" data-testid="reset-password-page">
      <p className="tracking-eyebrow text-[var(--eafg-muted)]">{t("auth.resetSubtitle")}</p>
      <h1 className="font-serif-display text-5xl mt-3 mb-10">{t("auth.resetTitle")}</h1>

      {done ? (
        <div className="space-y-6" data-testid="reset-done">
          <p className="text-[var(--eafg-copper)]">{t("auth.resetDone")}</p>
          <Link to="/login" className="inline-block border border-[var(--eafg-ink)] px-6 py-3 tracking-eyebrow hover:bg-[var(--eafg-ink)] hover:text-white">
            {t("auth.submitLogin")}
          </Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-6" data-testid="reset-form">
          <label className="block">
            <span className="tracking-eyebrow text-[var(--eafg-muted)] block mb-2">{t("auth.newPassword")}</span>
            <input
              type="password"
              required
              minLength={8}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full border-b border-[var(--eafg-line)] bg-transparent py-2 focus:outline-none focus:border-[var(--eafg-ink)]"
              data-testid="reset-password"
            />
          </label>
          <button
            type="submit"
            disabled={submitting}
            className="w-full bg-[var(--eafg-ink)] text-white py-4 tracking-eyebrow hover:bg-[var(--eafg-copper)] disabled:opacity-50"
            data-testid="reset-submit"
          >
            {t("auth.resetSubmit")}
          </button>
        </form>
      )}
    </div>
  );
}
